// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__23c83","footer":"ReportModalFilter_footer__3b7T5"};